const Keys = {
  ALT: 'Alt',
  ARROW: {
    DOWN: 'ArrowDown',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp'
  },
  BACKSPACE: 'Backspace',
  COMMAND: 'Meta',
  CONTROL: 'Control',
  DELETE: 'Delete',
  END: 'End',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  HOME: 'Home',
  META: 'Meta',
  MINUS: '-',
  NUMPAD: {
    MINUS: '-',
    PLUS: '+'
  },
  OPTION: 'Alt',
  PAGE: {
    DOWN: 'PageDown',
    UP: 'PageUp'
  },
  PLUS: '+',
  SHIFT: 'Shift',
  SPACE: ' ', // this is supposed to be an empty space
  TAB: 'Tab'
};

for (let keyCode = 65; keyCode < 65 + 26; keyCode += 1) {
  const letter = String.fromCharCode(keyCode);
  Keys[letter] = letter.toLowerCase();
}

export default Keys;
